module.exports = __webpack_public_path__ + "img/hard-work.476c13bd.png";